/**
 * 是否显示批注的枚举
 * 0 为默认(显示)，1 为显示，2 为不显示
 */
export var COMMENT_BOX_STATUS;
(function (COMMENT_BOX_STATUS) {
    COMMENT_BOX_STATUS[COMMENT_BOX_STATUS["DEFAULT"] = 0] = "DEFAULT";
    COMMENT_BOX_STATUS[COMMENT_BOX_STATUS["SHOW"] = 1] = "SHOW";
    COMMENT_BOX_STATUS[COMMENT_BOX_STATUS["HIDE"] = 2] = "HIDE";
})(COMMENT_BOX_STATUS || (COMMENT_BOX_STATUS = {}));
/**
 * 文档权限
 */
export var POLICY;
(function (POLICY) {
    POLICY[POLICY["SELF"] = 0] = "SELF";
    POLICY[POLICY["COOPERATION"] = 1] = "COOPERATION";
    POLICY[POLICY["VIEWABLE"] = 2] = "VIEWABLE";
    POLICY[POLICY["EDITABLE"] = 3] = "EDITABLE";
})(POLICY || (POLICY = {}));
/**
 * 文档有什么权限
 */
export var DOCUMENT_PRIVILEGE;
(function (DOCUMENT_PRIVILEGE) {
    DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["deny"] = 0] = "deny";
    DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["whitelist"] = 1] = "whitelist";
    DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["allOnlyRead"] = 2] = "allOnlyRead";
    DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["allOnlyWrite"] = 3] = "allOnlyWrite";
    DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["allOnlyExecute"] = 4] = "allOnlyExecute";
    DOCUMENT_PRIVILEGE[DOCUMENT_PRIVILEGE["invalidPolicy"] = 999] = "invalidPolicy";
})(DOCUMENT_PRIVILEGE || (DOCUMENT_PRIVILEGE = {}));
